﻿export default class Dashboard {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $window: $(window),
            pdfHost: null
        };

        this.init();
    }

    init() {

        this.initDocs();
        this.allDocDownload();
        this.AgreementDocument();

        $('#customFile').on('change', (e) => {
            //get the file name
            var fileName = e.target.files[0].name;
            //replace the "Choose a file" label
            $(e.currentTarget).next('.custom-file-label').addClass('filled').html(fileName);
        })

        $('.content-popup-close').on('click', (e) => {
            var $thisCarousel = $(e.currentTarget).closest('.carousel');
            if ($thisCarousel.find('.carousel-item').length == 1) {
                $thisCarousel.closest('.form-layout').remove();
            } else {
                $thisCarousel.find('.carousel-item.active, .carousel-indicators li.active').remove();
                $thisCarousel.find('.carousel-item:first-child, .carousel-indicators li:first-child').addClass('active');
            }
        })

        $('.dash-form .accordion-trigger').on('click', (e) => {
            $(e.currentTarget).closest('.form-row').find('.box-offer').toggleClass('with-btn').next('.btn').toggle();
        })

        if (window.innerWidth < '576') {
            $('#messageIndicators').closest('.form-layout').prependTo('.form-page-right').addClass('mt-3');
        }

        $('.CustData .input-field-wrap input').on('change', (e) => {
            $(e.currentTarget).addClass('edited');
            $('.CustData input[type="submit"]').val('Zapisz zmiany').addClass('content-popup-trigger');
            $(e.currentTarget).closest('.form-input-group').find('.form-error').text($('.form-error-global').text());
            if ($(e.currentTarget).data('validator-id') == "telephone") {
                $('.CustData [data-validator-id="email"]').attr('disabled', 'disabled').addClass('disabled');
                $('.CustData input[type="submit"]').attr('data-target', '.content-emailOTP');
            } else if ($(e.currentTarget).data('validator-id') == "email") {
                $('.CustData [data-validator-id="telephone"]').attr('disabled', 'disabled').addClass('disabled');
                $('.CustData input[type="submit"]').attr('data-target', '.content-mobileOTP');
            } else {
                $('.CustData input[type="submit"]').attr('data-target', '.content-mobileOTP');
            }
        });

        //$('form').off('submit').on('submit', (e) => {
        //    e.preventDefault();
        //    return false;
        //});

        $('.CustData input[type="submit"]').on('click', (e) => {
            if ($(e.currentTarget).data('target') == undefined) {   //not set target
                e.preventDefault();
                //redirect back to dashboard
                window.location.href = $('.offersLink a').attr('href');
            }
        });

        //Copy CRAN to clipboard
        $('.page-dash').on('click', '.cranCopy', function () {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($(this).closest('.content-popup-inner').find('.cranNo').text().replace(/\s/g, '')).select();
            document.execCommand("copy");
            $temp.remove();
        });

        $('#ShowOffer').on('click', function () {
            $("#bannerLink").hide();
            $("#offersLink").show();
        });

        $('#ShowDecline').on('click', function () {

            $('.loading-screen').show();
            $.ajax({
                url: '/api/sitecore/DashboardLoan/DeclineMessage',
                type: 'get',
                data: '{"datasourceid":"' + $('#DasboardSourceItemID').val() + '"}',
                contentType: 'application/json; charset=utf-8',
                cache: false,
                async: true,
                success: function (result) {
                    $('.loading-screen').hide();
                },
                complete: function (data) {
                    $('.loading-screen').hide();
                }
            });
        });

        $('#ShowSubStatus.goto-offer').on('click', function (event) {
            event.preventDefault();
            $('.loading-screen').show();
            getAjaxData('/api/sitecore/DashboardLoan/GetOffersAndRedirect', "GET", true, "", function (data) {
                if (data) {
                    if (data.IsSuccess) {
                        window.location.href = $('#ShowSubStatus.goto-offer').attr('href');
                    } else {
                        $('.loading-screen').hide();
                        return;
                    }
                } else {
                    $('.loading-screen').hide();
                    return;
                }
            });            
        });

        $('#ShowSubStatus.goto-verification').on('click', function (event) {
            event.preventDefault();
            $('.loading-screen').show();
            getAjaxData('/api/sitecore/DashboardLoan/GetVerificationsAndRedirect', "GET", true, "", function (data) {
                if (data) {
                    if (data.IsSuccess) {
                        if (data.IsPreVerifDocsDone) {
                            window.location.href = $('#ShowSubStatus.goto-verification').data('verification-url');
                        }
                        else {
                            window.location.href = $('#ShowSubStatus.goto-verification').attr('href');
                        }                        
                    } else {
                        $('.loading-screen').hide();
                        return;
                    }
                } else {
                    $('.loading-screen').hide();
                    return;
                }
            });
        });

        $("body").on('click', 'li.DirectDebitOption', (e) => {
            var dataSource = {
                "agreementId": $(e.currentTarget).parent().parent().find($('input[name=agreementId]')).val()
            };

            $('.loading-screen').show();
            $('input[name=chk-direct-debit]').prop('checked', false);
            getAjaxData('/api/sitecore/DashboardLoan/GetDirectDebitConsent', "POST", true, dataSource, function (data) {
                if (data) {
                    if (data.IsConsent) {
                        $('.loading-screen').hide();
                        $('input[name=chk-direct-debit]').prop('checked', true);
                    } else {
                        $('.loading-screen').hide();
                        return;
                    }
                } else {
                    $('.loading-screen').hide();
                }
            });

            $("body").on('change', 'input[name=chk-direct-debit]', (e) => {
                if ($(e.currentTarget).is(':checked')) {
                    $('div.content-popup.visible input#btn-direct-debit-consent').prop('disabled', false).removeClass('disabled');
                    $('div.content-popup.visible input#btn-direct-debit-consent').on('click', function () {
                        $('.loading-screen').show();
                        getAjaxData('/api/sitecore/DashboardLoan/UpdateDirectDebitConsent', "POST", true, dataSource, function (data) {
                            if (data) {
                                if (data.IsSuccess) {
                                    $('.loading-screen').hide();
                                } else {
                                    $('.loading-screen').hide();
                                    return;
                                }
                            } else {
                                $('.loading-screen').hide();
                            }
                        });
                    })
                } else {
                    $('div.content-popup.visible input#btn-direct-debit-consent').off('click').prop('disabled', true).addClass('disabled');
                }
            });
        })
    }

    allDocDownload() {
        //Download all documents
        var $this = this;
        $("body").on("click", ".content-popup.visible .downloadAllDocs a", function (e) {
            e.preventDefault();
            $(".loading-screen").show();

            $('.content-popup.visible .docList li').each(function (index, element) {
                //var docFileName = $(element).find('span').text().normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[/\\?%*:|"<>]/g, '-');
                var docFileName = $(element).find($('input[name=documentTitle]')).val().normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[\.\s/\\?%*:|"<>]/g, '-');
                var documentId = $(element).find($('input[name=documentId]')).val();
                var agreementNumber = $(element).find($('input[name=agreementNumber]')).val();
                var partnerName = $(element).find($('input[name=partnerName]')).val();
                var customerId = $(element).find($('input[name=customerId]')).val();

                setTimeout(function () {
                    $this.printTermsandConditionForm('agreement', docFileName, documentId, agreementNumber, partnerName, customerId);
                }, (index == 0 ? 0 : 500));

            });
        });
    }

    AgreementDocument() {
        //POA
        var $this = this;
        $("body").on("click", ".pdfDoc", function (e) {
            e.preventDefault();
            //var poaFileName = $('[data-validator-id="poa-doc-filename"]').val();
            //var agreementFileName = $(this).closest('li').find($('input[name=documentTitle]')).val().normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[\.\s/\\?%*:|"<>]/g, '-');
            var agreementFileName = $(this).closest('li').find($('input[name=documentTitle]')).val().normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[\.\s/\\?%*:|"<>]/g, '');
            var documentId = $(this).closest('li').find($('input[name=documentId]')).val();
            var agreementNumber = $(this).closest('li').find($('input[name=agreementNumber]')).val();
            var partnerName = $(this).closest('li').find($('input[name=partnerName]')).val();
            var extend = $(this).closest('li').find($('input[name=extend]')).val();
            var customerId = $(this).closest('li').find($('input[name=customerId]')).val();
            //if (redirectIfNotSignedIn()) {
            var params = '';//_loanOfferType == "hybrid" ? '&offertype=hybrid' : '';
            //pdfHost.showPdfFromHandler($(this).text(), 'lagr', true, params);
            $this.dom.pdfHost.showPdfFromHandler('Pobierz', 'agreement', true, params, agreementFileName, documentId, agreementNumber, partnerName, extend, customerId);
            //}
            $this.modalHeight();
        });
    }

    // Open PDF File via handler
    initDocs() {
        var $this = this;
        var iframeHeight;
        var overflowStyle;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            overflowStyle = '-webkit-overflow-scrolling:touch; overflow:auto;';
            iframeHeight = 'height: auto;';
        } else {
            overflowStyle = 'overflow:hidden;';
            iframeHeight = 'height: 100%;';
        }
        this.dom.pdfHost = this.dom.pdfHost || (function () {
            return {
                showPdf: function (url, title, fileType, showInline) {
                    //var URL = ('/custom/handlers/getfile.ashx?content-type=pdf&file-type=' + fileType + params);

                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                        window.open(url, '_blank', '', '');
                    }
                    else {
                        if (showInline) {
                            var closeText = $('#hiddenClose').val();
                            var pdfPopup = $(`
                            <div class="verify-popup visible">
                              <div class="loading-modal"></div>
                              <div class="content-popup popup-full-width pdf-popup center">
                                <a href="#" class="content-popup-close">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.828 12.828">
                                    <g id="close" transform="translate(1.414 1.414)">
                                      <line fill="none" stroke="#adda43" stroke-linecap="round" stroke-width="2px" data-name="Line 28" x2="10" y2="10" />
                                      <line fill="none" stroke="#adda43" stroke-linecap="round" stroke-width="2px" data-name="Line 29" x2="10" y2="10" transform="translate(10) rotate(90)" />
                                    </g>
                                  </svg>
                                </a>
                                <div class="content-popup-inner">
                                  <iframe style="position: relative; ${iframeHeight} min-width:100%; max-width:100%; width: 100%; text-align:center;" src="${url}" frameBorder="0">
                                    <p>It appears you do not have a PDF plugin for this browser. You can click <a href="${url}" target="_blank">here</a> to download the file.</p>
                                    <p>Alternatively, click <a href="http://get.adobe.com/uk/reader/" target="_blank">here</a> to download the PDF reader.</p>
                                  </iframe>
                                  <button type="button" class="btn content-popup-close" data-dismiss="modal">`+ closeText + `</button>
                                </div>
                              </div>
                            </div>
                          `);
                            $('body').append(pdfPopup);
                            $('body').on('click', '.content-popup-close', function () {
                                $('.verify-popup').remove();
                            })
                        } else {
                            window.open(url, '_blank', '', '');
                        }
                    }
                },
                showPdfFromHandler: function (title, fileType, showInline, params, documentTitle, documentId, agreementNumber, partnerName, extend, customerId) {
                    var dDate = new Date();
                    var sDate = dDate.getDate() + '-' + (dDate.getMonth() + 1) + '-' + dDate.getFullYear() + '_' + dDate.getHours() + '-' + dDate.getMinutes();
                    documentTitle = documentTitle + '_' + sDate;
                    //For IE browser (which ignores handler filename) insert document name after ashx (ignored by other browsers)
                    var URL = ('/custom/handlers/getverificationfile.ashx/' + documentTitle + '?content-type=pdf&document-title=' + documentTitle + '&file-type=' + fileType + '&documentId=' + documentId + '&agreementNumber=' + agreementNumber + '&partnerName=' + partnerName + '&extend=' + extend + '&customerId=' + customerId);

                    $this.dom.pdfHost.showPdf(URL, title, fileType, showInline, params);
                }
            };
        })();
    };

    modalHeight() {
        setTimeout(function () {
            if ($('.modal-body').length > 0) {
                $('.modal-body').height($(window).height() - 300);
                $(window).resize(function () {
                    $('.modal-body').height($(window).height() - 300);
                });
            }
        }, 500);
    }

    printTermsandConditionForm(fileType, documentTitle, documentId, agreementNumber, partnerName, customerId) {
        //isHybrid = isHybrid || false;
        var url = ('/custom/handlers/getverificationfile.ashx/' + documentTitle + '?content-type=pdf&document-title=' + documentTitle + '&file-type=' + fileType + '&documentId=' + documentId + '&agreementNumber=' + agreementNumber + '&partnerName=' + partnerName + '&customerId=' + customerId);
        var a = document.createElement('a');
        var dDate = new Date();
        var sDate = dDate.getDate() + '-' + (dDate.getMonth() + 1) + '-' + dDate.getFullYear() + '_' + dDate.getHours() + '-' + dDate.getMinutes();
        var fileName = documentTitle + "_" + sDate + ".pdf";
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        //xhr.timeout = 4000; // time in milliseconds
        xhr.responseType = 'blob';
        var $this = this;
        xhr.onload = function (e) {
            if (this.status == 200) {
                var blob = this.response;
                if (blob.size == 0) {
                    //$this.printTermsandConditionForm(null, fileName);
                    cLog('blob size 0');
                }
                if (blob.size > 0) {
                    //$('.POAcontrol').removeClass("hide").show();
                    if (/iphone|ipad|macintosh/i.test(navigator.userAgent)) {
                        //For iphone devices
                        a.href = url;
                        a.target = '_blank';
                        a.style = "display: none";
                        document.body.appendChild(a);
                        a.click();
                    } else if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        //IE 10+
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        //Firefox, Chrome
                        var blobUrl = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
                        a.href = blobUrl;
                        a.download = fileName;
                        a.style = "display: none";
                        //document.body.appendChild(a);
                        a.click();
                    }
                } //else if ($("#POANotAvailable").length > 0) {
                //setTimeout(function () {
                //    $(".loading-screen").hide();
                //    $("#POANotAvailable").modal("show");
                //}, $("[name=poaNAWaitTime]").val());
                //}

            }
            else {
                //redirectToLogin();
            }
            $(".loading-screen").hide();

        };
        xhr.ontimeout = function (e) {
            //$this.printTermsandConditionForm(null, fileName);
            cLog('xhr timeout');
            // XMLHttpRequest timed out. Do something here.
        };
        setTimeout(function () {
            xhr.send();
        }, 4000);
    }
}